export default __webpack_public_path__ + "static/media/shutterstock_341144111_ENLACES_DE_INTERES.6531be5b.webp";